import { useLocation } from 'react-router-dom';
import ExpandableFooter from 'components/ExpandableFooter';

export default function Footer({ paperworkCard = false }) {
  const { pathname } = useLocation();
  if (pathname.replace(/\/+$/, '').toLowerCase() === '/paperwork' && !paperworkCard) return null;
  return <ExpandableFooter paperworkCard={paperworkCard} />;
}
